/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Container = require('./Container');

var DustbinSorted = React.createClass({displayName: 'DustbinSorted',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Container, null), 
        React.createElement("hr", null), 
        React.createElement("p", null, 
          "Several different dustbins can handle several types of items. Note that the last dustbin is special: it can also handle files from your hard drive."
        )
      )
    );
  }
});

module.exports = DustbinSorted;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-interesting/index.js
 ** module id = 142
 ** module chunks = 0
 **/